"use strict";
function stubFalse() {
    return false;
}
module.exports = stubFalse;
//# sourceMappingURL=stubFalse.js.map